import { Component, Input } from '@angular/core';
import { slug } from '@assetaccountant/core/utils/slug';

@Component({
  selector: 'app-name-cell',
  templateUrl: './name-cell-renderer.component.html',
  styleUrls: ['./name-cell-renderer.component.scss'],
  standalone: false,
})
export class NameCellComponent {
  @Input() data:
    | {
        type: 'PARENT';
        parentGroup: string;
        groupId?: undefined;
        groupName?: undefined;
        name?: undefined;
        code?: undefined;
        description?: undefined;
        assetCount?: undefined;
      }
    | {
        type: 'GROUP';
        parentGroup?: undefined;
        groupId: string;
        groupName: string;
        name?: undefined;
        code?: undefined;
        description?: undefined;
        assetCount?: number;
      }
    | {
        type: 'ASSET';
        parentGroup?: undefined;
        groupId?: string;
        groupName?: undefined;
        id: string;
        name: string;
        code?: string;
        description?: string;
        assetCount?: undefined;
      };

  node: any;

  get colWidth() {
    return 350;
  }

  get hasParentGroup() {
    return !!this.data?.parentGroup;
  }

  toPoolCode(): string {
    if (this.data.groupId) {
      return this.data.groupId.replace('pools/', '');
    } else {
      return '';
    }
  }

  toPoolFragment(id: string): string | undefined {
    if (id) {
      if (this.data.groupId) {
        const fragment = id.replace('pools/', '').replace(this.toPoolCode(), '');
        if (fragment.startsWith('/')) {
          return fragment.substring(1);
        } else {
          return fragment;
        }
      } else {
        return '';
      }
    }
    return undefined;
  }

  routerLink() {
    switch (this.data.type) {
      case 'GROUP': {
        if (isNaN(Number(this.data.groupId))) {
          return [`../../../years/-/pools/${this.toPoolCode()}`];
        }
        return [`../assetgroups/${this.data.groupId}`];
      }

      case 'ASSET': {
        // use the same logic as server
        if (isNaN(Number(this.data.id))) {
          return [`../../../years/-/pools/${this.toPoolCode()}/transactions`];
        }
        return [`./${this.data.id}-${slug(this.data.name)}`];
      }
    }

    return null;
  }

  fragment() {
    if (this.data.type === 'ASSET') {
      if (isNaN(Number(this.data.id))) {
        const id = this.toPoolFragment(this.data.id);
        if (id) {
          return `/${id}`;
        }
      }
    }
    return undefined;
  }

  onToggleExpanded() {
    this.node?.setExpanded(!this.node.expanded);
  }
}
